var map = {
	"./Central-mobile.jpg": 12203,
	"./South-mobile.jpg": 38511,
	"./default-mobile.jpg": 17991,
	"./mandurah-times-mobile.jpg": 65799,
	"./northern-suburbs-mobile.jpg": 75727,
	"./western-suburbs-mobile.jpg": 41619
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97018;